import React from 'react';
import AlgorithmDistributions from './algorithm-distributions';
import PublisherDropdown from './publisher-dropdown';

const AuctionDistributionOverride = (
	{
		publishers,
		distributions,
		distributionStatus,
		selectPublisher,
		updateDistribution,
		addOverride,
		closeModal,
	}
) => {
	return (
		<div className="auction-distribution-container">
			<div className="config-override-modal">
				<div className="distribution-override">
					<h3>New Auction Configuration Override</h3>
					<PublisherDropdown
						publishers={publishers}
						selectPublisher={selectPublisher}
					/>
					<AlgorithmDistributions
						distributions={distributions}
						distributionStatus={distributionStatus}
						selectedConfig="new"
						updateDistribution={updateDistribution}
						type="override"
						isOverride={true}
					/>
				</div>
				<button
					className="add-new"
					onClick={() => addOverride(true)}>
					Add New
				</button>
				<button
					className="cancel-btn"
					onClick={() => closeModal(false, 'overrideOpen', 'cancel')}>
					Cancel
				</button>
			</div>
		</div>
	);
};

export default AuctionDistributionOverride;
